import React from 'react';
/* Allow to access a fresh closures in the function but returns stable reference during rerenders */
export function useCallbackRef(callback) {
    const ref = React.useRef({
        stableFn: (...args) => ref.current.callback(...args),
        callback,
    });
    // useLayoutEffect for React <18
    React.useInsertionEffect(() => {
        ref.current.callback = callback;
    });
    // eslint-disable-next-line react-hooks/refs
    return ref.current.stableFn;
}
